/* -------------------------------------------------------------------------- */
/*                            External Dependencies                           */
/* -------------------------------------------------------------------------- */
import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { resetValdationSchema } from 'utils/validation-schema';

/* -------------------------- Internal Dependencies ------------------------- */
import Input from 'components/input';
import Button from 'components/button';
import { resetPassword } from 'redux/user/actions';
import { selectisLoading } from 'redux/user/selector';
import AuthLayout, {
	AuthStylingLayoutChildren,
} from '../../components/layout/auth-layout';
import SEO from 'components/seo';

/* ----------------------------- Reset propTypes ---------------------------- */
const propTypes = {
	isLoading: PropTypes.bool,
	dispatch: PropTypes.func,
};

const Reset = ({ dispatch, isLoading }) => {
	return (
		<AuthLayout>
			<SEO title="New password" />
			<AuthStylingLayoutChildren>
				<h3>Create new password</h3>
				<p className="intro__text">Set new password for your account</p>
				<Formik
					initialValues={{ password: '', newPassword: '' }}
					validationSchema={resetValdationSchema}
					onSubmit={async ({ password }) => {
						dispatch(resetPassword?.({ password }));
					}}
				>
					{({
						values,
						errors,
						touched,
						handleChange,
						handleBlur,
						handleSubmit,
					}) => (
						<form onSubmit={handleSubmit}>
							<Input
								hasStrip
								id="password"
								name="password"
								type="password"
								label="Type New Password"
								placeholder="Type New Password"
								value={values.password}
								onChange={handleChange}
								onBlur={handleBlur}
								errorMessage={errors.password}
								isInvalid={errors.password && touched.password}
							/>
							<Input
								hasStrip
								id="newPassword"
								name="newPassword"
								type="password"
								label="Confirm New Password"
								placeholder="Confirm New Password"
								value={values.newPassword}
								onChange={handleChange}
								onBlur={handleBlur}
								errorMessage={errors.newPassword}
								isInvalid={errors.newPassword && touched.newPassword}
							/>
							<Button
								type="submit"
								className="btn-developp btn-block"
								isLoading={isLoading}
								disabled={isLoading}
							>
								Create new password
							</Button>
						</form>
					)}
				</Formik>
			</AuthStylingLayoutChildren>
		</AuthLayout>
	);
};

Reset.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
	isLoading: selectisLoading,
});

export default connect(mapStateToProps)(Reset);
